import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "./useAppStore";
import {
  fetchAllianceById,
  clearCurrent,
} from "../store/slices/alliancesSlice";

export function useAllianceDetail() {
  const { id } = useParams<{ id: string }>();
  const dispatch = useAppDispatch();
  const { current, loading } = useAppSelector((s) => s.alliances);

  useEffect(() => {
    if (id) dispatch(fetchAllianceById(id));
    return () => {
      dispatch(clearCurrent());
    };
  }, [dispatch, id]);

  return { alliance: current, loading };
}
